angular.module 'zc.commonApi'

.factory "PageType", ($resource, $q, Api, pageTypeServiceRequestTransformer) ->
  URL = "/api/projects/:projectId/page_types/:id"
  PageType = $resource Api.path(URL), { projectId: @projectId, id: @id },
    query:
      method: 'GET'
      isArray: false # Rails returns object instead of array
    create:
      method: 'POST'
      transformRequest: pageTypeServiceRequestTransformer
    createMany:
      method: 'POST'
      url: Api.path("/api/projects/:projectId/page_types/create_many")
      headers:
        'Content-Type': 'application/json'
    update:
      method: 'PATCH'
      transformRequest: pageTypeServiceRequestTransformer
    updateMany:
      method: 'PATCH'
      url: Api.path("/api/projects/:projectId/page_types/update_many")
      headers:
        'Content-Type': 'application/json'
    destroy:
      method: 'DELETE'
    options:
      method: 'GET'
      cache: true
    save:
      method: 'POST'
      headers:
        'Content-Type': undefined
      transformRequest: (data) ->
        formData = new FormData()
        angular.forEach data, (val, key) ->
          formData.append key, val
        formData

  service =
    CUSTOM_PAGE_TYPE: '_custom_'
    # Should be in the responseTransformer after getPageTypeOptions moved to meta
    transformCustomPageType: (page_type_options, page_type)->
      (page_type_option[1] for page_type_option in page_type_options)
      options = (page_type_option[1] for page_type_option in page_type_options)
      unless page_type.page_type in options
        page_type.custom_name = page_type.page_type
        page_type.page_type = service.CUSTOM_PAGE_TYPE
      page_type

    create: (params, obj) ->
      $q.all [
        service.getPageTypeOptions params.projectId
        PageType.create({ projectId: params.projectId }, obj).$promise
      ]
      .then ([page_type_options, res]) ->
        if res.success
          return service.transformCustomPageType(page_type_options, res.page_type)
        else
          $q.defer().reject res

    createMany: (params, obj) ->
      PageType.createMany({ projectId: params.projectId}, {page_types: obj}).$promise

    update: (params, update) ->
      $q.all [
        service.getPageTypeOptions params.projectId
        PageType.update(params, update).$promise
      ]
      .then ([page_type_options, res]) ->
        if res.success
          return service.transformCustomPageType(page_type_options, res.page_type)
        else
          $q.defer().reject res

    updateMany: (params, update) ->
      PageType.updateMany({ projectId: params.projectId}, {page_types: update}).$promise

    all: (projectId) ->
      $q.all [
        service.getPageTypeOptions projectId
        PageType.query({projectId: projectId}).$promise
      ]
      .then ([page_type_options, res]) ->
        page_types = res.page_types.map (page_type)->
          service.transformCustomPageType page_type_options, page_type
        return page_types

    destroy: (pageType) ->
      $q (resolve, reject) ->
        PageType.destroy({ projectId: pageType.project_id, id: pageType.id}).$promise.then (res) ->
          if res.success
            resolve res
          else
            reject()
        , (err) ->
          reject err

    new: (options) ->
      DEFAULT_OPTIONS = {
        required_device: 'both'
        evaluator: 'url'
        page_type: ''
        match_type: ''
        custom_name: ''
      }
      page_type_options = DEFAULT_OPTIONS
      page_type_options = angular.extend(page_type_options, options) if options
      new PageType(page_type_options)


    PageTypeOptions: {}

    getPageTypeOptions: (projectId) ->
      $q (resolve, reject) ->
        return resolve(service.PageTypeOptions[projectId]) if service.PageTypeOptions[projectId]
        # hackish but works (TODO: move to meta)
        PageType.options {projectId: projectId, id: "page_type_options"}, (res) ->
          return reject null unless res.success
          service.PageTypeOptions[projectId] = res.page_types
          resolve res.page_types

    getMatchTypes: (projectId) ->
      $q (resolve, reject) ->
        # hackish but works (TODO: move to meta)
        PageType.options {projectId: projectId, id: "match_types"}, (res) ->
          return reject null unless res.success
          resolve res.match_types

    getDevices: (projectId) ->
      $q (resolve, reject) ->
        # hackish but works (TODO: move to meta)
        PageType.options {projectId: projectId, id: "devices"}, (res) ->
          return reject null unless res.success
          resolve res.devices

    isCustomPageType: (page_type)->
      page_type.page_type == service.CUSTOM_PAGE_TYPE

  service

# need to remove id, created_at, update_at required for saving
.factory 'pageTypeServiceRequestTransformer', ($injector) ->

  doTransform = (elem) ->
    elem = _.assignIn({}, elem)
    delete(elem["id"])
    delete(elem["isOk"])
    PageType = $injector.get("PageType")
    elem.page_type = elem.custom_name if elem.page_type == PageType.CUSTOM_PAGE_TYPE
    return elem

  return (data) ->
    if data.page_type
      data.page_type = doTransform(data.page_type)
    return angular.toJson(data)



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/page_type_service.js.coffee